import React from 'react'
import FreebieSelectorEntitlement from './FreebieSelectorEntitlement'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'

const DiscountApplicationRulesFreebieSelector = () => {
  return (
    <div className='flex flex-col '>
      <FreebieSelectorEntitlement />

      <PurchaseConditions />
      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesFreebieSelector
